module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-regal-03.7f5f37af.jpeg";